// src/components/notifications/NotificationsActionsBar.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import {
  MarkEmailRead as MarkReadIcon,
} from '@mui/icons-material';

export default function NotificationsActionsBar({
  selectedCount,
  totalFilteredCount,
  totalCount,
  unreadCount,
  onSelectAll,
  onMarkAllAsRead,
}) {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
      <Box display="flex" alignItems="center" gap={2}>
        <Button
          size="small"
          onClick={onSelectAll}
          disabled={totalFilteredCount === 0}
        >
          {selectedCount === totalFilteredCount 
            ? t('notifications:actions_bar.deselect_all') 
            : t('notifications:actions_bar.select_all')
          }
        </Button>
        {unreadCount > 0 && (
          <Button
            size="small"
            startIcon={<MarkReadIcon />}
            onClick={onMarkAllAsRead}
          >
            {t('notifications:actions_bar.mark_all_read', { count: unreadCount })}
          </Button>
        )}
      </Box>
      <Typography variant="body2" color="text.secondary">
        {t('notifications:actions_bar.notifications_count', { 
          filtered: totalFilteredCount, 
          total: totalCount 
        })}
      </Typography>
    </Box>
  );
}